
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[p1]/[p2]/[p3]",
      function () {
        return require("private-next-pages/[p1]/[p2]/[p3]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[p1]/[p2]/[p3]"])
      });
    }
  